import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useQuery } from "react-query";
import { RotatingLines } from "react-loader-spinner";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { packageContext } from "../../context/PackageContext/PackageContext";
import './Package.css';
import Slider from "react-slick";

export default function PackageDetails() {
  let params = useParams();
  let navigate = useNavigate();
  let { addPackageToCart } = useContext(packageContext);

  async function addPackage(pckid) {
    let response = await addPackageToCart(pckid);
    console.log(response);
    if (localStorage.getItem("userToken") === null) {
      navigate("/login");
      toast.error("Error adding product,You Must login");
    } else if (response.data.message === "Item(s) added to cart.") {
      toast.success("product successfully Added", {
        duration: 3000,
        position: "top-center",
      });
    } else {
      toast.error("Error adding product");
    }
  }

  function getPackageDetails(id) {
    return axios.get(
      `https://vehex-production.up.railway.app/package/getpackageById/${id}`
    );
  }

  let { isLoading, isError, data } = useQuery("productdetails", () =>
    getPackageDetails(params.id)
  );
  console.log(data);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      {isLoading ? (
        <div className="position-fixed top-50 start-50 translate-middle">
          <RotatingLines
            strokeColor="green"
            strokeWidth="5"
            animationDuration="1"
            width="85"
            visible={true}
          />
        </div>
      ) : (
        <>
          {data?.data.packagee ? (
            <>
              <div className=" container py-3">
                <div className="row packageDetail m-auto w-75 py-2 align-items-center">
                  <Helmet>
                    <meta
                      name="description"
                      content={data?.data.packagee.description}
                    />
                    <title>{data?.data.packagee.name}</title>
                  </Helmet>
                  <div className="col-md-3 my-3">
                  <Slider {...settings}>
                        {data?.data.packagee.images.map((img, index) => {
                          return (
                            <div>
                              <img
                                src={img.url}
                                className="slider-image"
                                alt={data?.data.packagee.name}
                              />
                            </div>
                          );
                        })}
                      </Slider>
                    {/* <div>
                      <img
                        src={data?.data.packagee.logo.url}
                        className="slider-image"
                        alt={data?.data.packagee.name}
                      />
                    </div> */}
                  </div>

                  <div className="col-md-9">
                    <h4 className=" main-color">{data?.data.packagee.name}</h4>
                    <p className="fs-6">{data?.data.packagee.description}</p>
                    <h6 className="main-color">
                      Price :{" "}
                      <span className="text-black">
                        {data?.data.packagee.price} SAR
                      </span>
                    </h6>
                    <button
                      onClick={() => {
                        addPackage(data?.data.packagee._id);
                        // setcounter(counter+1)
                      }}
                      className=" bg-main-color text-white w-100 mt-2 rounded-2"
                    >
                      Add to Cart <i class="fa-solid fa-cart-shopping"></i>
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
}
